export const dummy_data = [
  {
    id: 1,
    name: "Medical Issue",
    content: "<p>Dear @patient_name</p>",
  },
];

export const patientInfo = [
  {
    name: "Patient Name",
    value: "full_name",
  },
  {
    name: "Gender",
    value: "gender",
  },
  {
    name: "Age",
    value: "age",
  },
  {
    name: "Date of Birth",
    value: "dob",
  },
  {
    name: "Mobile No",
    value: "mobile_no",
  },
];
